<template>
  <div id="content-container">
    <RecordIndex :category="2"></RecordIndex>
  </div>
</template>

<script>
import RecordIndex from './index'

export default {
  components: {
    RecordIndex,
  },
}
</script>